(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-icon-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!window.__customIconWithTextInitialized) {
    window.__customIconWithTextInitialized = true;

    const SECTION_SEL = '.custom-icon-with-text';
    const CARD_SEL = '.custom-icon-with-text__card';
    const TRACK_SEL = '[data-carousel-track]';
    const PREV_SEL = '[data-carousel-prev]';
    const NEXT_SEL = '[data-carousel-next]';
    const CAROUSEL_CLASS = 'custom-icon-with-text__grid--mobile-carousel';
    const instances = new WeakMap();

    const debounce = (callback, wait = 120) => {
      let timer = null;
      return (...args) => {
        if (timer) clearTimeout(timer);

        timer = setTimeout(() => callback(...args), wait);
      };
    };

    const equalizeCardHeights = (section) => {
      const cards = Array.from(section.querySelectorAll(CARD_SEL));
      if (!cards.length) return;

      cards.forEach((card) => {
        card.style.minHeight = '0px';
      });
      let maxHeight = 0;
      cards.forEach((card) => {
        maxHeight = Math.max(maxHeight, card.offsetHeight);
      });
      cards.forEach((card) => {
        card.style.minHeight = `${maxHeight}px`;
      });
    };

    const setupCarouselControls = (section) => {
      const track = section.querySelector(TRACK_SEL);
      const previous = section.querySelector(PREV_SEL);
      const next = section.querySelector(NEXT_SEL);

      if (!(track instanceof HTMLElement)) return null;
      if (!(previous instanceof HTMLButtonElement) || !(next instanceof HTMLButtonElement)) return null;
      if (!track.classList.contains(CAROUSEL_CLASS)) return null;

      const getScrollStep = () => {
        const firstItem = track.querySelector('.custom-icon-with-text__item');
        if (!(firstItem instanceof HTMLElement)) return track.clientWidth;

        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return firstItem.getBoundingClientRect().width + gap;
      };

      const updateControlState = () => {
        const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maxScrollLeft - 1 || maxScrollLeft <= 0;
      };

      const scrollToPrevious = () => {
        track.scrollBy({
          left: getScrollStep() * -1,
          behavior: 'smooth',
        });
      };

      const scrollToNext = () => {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      };

      const onScroll = debounce(updateControlState, 40);

      previous.addEventListener('click', scrollToPrevious);
      next.addEventListener('click', scrollToNext);
      track.addEventListener('scroll', onScroll, { passive: true });
      updateControlState();

      return {
        update: updateControlState,
        destroy: () => {
          previous.removeEventListener('click', scrollToPrevious);
          next.removeEventListener('click', scrollToNext);
          track.removeEventListener('scroll', onScroll);
        },
      };
    };

    const setup = (section) => {
      if (!(section instanceof HTMLElement) || instances.has(section)) return;

      const onResize = debounce(() => equalizeCardHeights(section));
      const carouselControls = setupCarouselControls(section);
      const observer = new ResizeObserver(onResize);
      observer.observe(section);
      window.addEventListener('resize', onResize, { passive: true });
      if (carouselControls) {
        window.addEventListener('resize', carouselControls.update, { passive: true });
      }

      const images = section.querySelectorAll('.custom-icon-with-text__icon-image');
      images.forEach((image) => {
        if (!(image instanceof HTMLImageElement) || image.complete) return;

        image.addEventListener('load', onResize, { once: true });
        image.addEventListener('error', onResize, { once: true });
      });

      requestAnimationFrame(() => {
        equalizeCardHeights(section);
        requestAnimationFrame(() => {
          if (carouselControls) carouselControls.update();
        });
      });

      instances.set(section, { observer, onResize, carouselControls });
    };

    const teardown = (section) => {
      const instance = instances.get(section);
      if (!instance) return;

      instance.observer.disconnect();
      window.removeEventListener('resize', instance.onResize);
      if (instance.carouselControls) {
        window.removeEventListener('resize', instance.carouselControls.update);
        instance.carouselControls.destroy();
      }
      instances.delete(section);
    };

    const setupAll = (root = document) => {
      root.querySelectorAll(SECTION_SEL).forEach((section) => setup(section));
    };

    const teardownAll = (root) => {
      root.querySelectorAll(SECTION_SEL).forEach((section) => teardown(section));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setupAll());
    } else {
      setupAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      setupAll(target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      teardownAll(target);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      // this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
      //commented above code for tt-custom-search-bar
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
